// extracted by mini-css-extract-plugin
export default {"swiggyMoneyInfoCta":"qnebRa"};